import { Region } from './common';
import { PriceGeoType } from './pricePackages';

export type RegionsEditorsState = Record<string, RegionsEditorState>;

export interface RegionsEditorState {
    selectedMap: Record<number, boolean>;
    expandedMap: Record<number, boolean>;
    filteredMap: Record<number, boolean>;
    idForScrolling?: string;
    isOpen: boolean;
    searchValue: string;
    geoType?: PriceGeoType;
    isFixed?: boolean;
}

export interface RegionsEditorQuickSelectItem {
    title: string;
    selectedMap: Record<number, boolean>;
}

export interface RegionsEditorCommonNodeInfoForQuickSelectItem {
    title: string;
    nodeIds: string[];
}

export enum RegionsQuickSelectMode {
    REPLACE = 'REPLACE',
    CHANGE = 'CHANGE'
}

export interface RegionsEditorData {
    id: string;
    selectedMap: Record<number, boolean>;
    tree: Region[];
    geoType?: PriceGeoType;
    isFixed?: boolean;
}
